import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import utils from '@/helpers/utils.js';
import _ from 'lodash';
import axios from 'axios';
export default {
  name: 'CreationFirstStep',
  props: {
    existing: {
      type: [Object, Array],
      required: false,
      default: function _default() {
        return {};
      }
    },
    nextStep: {
      type: Function,
      required: true
    },
    previousStep: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    var _this$existing, _this$existing2;

    return {
      seriesName: null,
      seriesSlug: null,
      seriesDescription: null,
      seriesCertification: true,
      seriesLanguage: null,
      seriesMinToCertificate: (_this$existing = this.existing) === null || _this$existing === void 0 ? void 0 : _this$existing.minToCertificate,
      seriesWorkload: (_this$existing2 = this.existing) === null || _this$existing2 === void 0 ? void 0 : _this$existing2.workload,
      seriesValidity: null,
      languages: [],
      languageOptions: [{
        label: 'Português (Brasil)',
        value: 'pt-br'
      }],
      validityOptions: [{
        label: '1 mês',
        value: '1 month'
      }, {
        label: '6 meses',
        value: '6 months'
      }, {
        label: '1 ano',
        value: '12 months'
      }, {
        label: '2 anos',
        value: '24 months'
      }, {
        label: 'Vitalício',
        value: 'none'
      }]
    };
  },
  computed: {
    dataFormat: function dataFormat() {
      var format = {
        slug: this.seriesSlug,
        certificates: this.seriesCertification,
        minToCertificate: Number(this.seriesMinToCertificate),
        workload: this.seriesWorkload,
        expiration: this.seriesValidity,
        courseLanguage: this.seriesLanguage,
        languages: {}
      };
      var language = this.seriesLanguage;
      format.languages[language] = {
        title: this.seriesName,
        description: this.seriesDescription
      };
      return format;
    },
    isNextStepDisabled: function isNextStepDisabled() {
      return !(this.seriesName && this.seriesSlug && this.seriesDescription && this.seriesLanguage && (this.seriesMinToCertificate && this.seriesCertification || !this.seriesCertification) && this.seriesWorkload && this.seriesValidity);
    }
  },
  watch: {
    seriesName: function seriesName() {
      this.handleTitleChange();
    }
  },
  beforeMount: function beforeMount() {
    var _this$existing3;

    this.worldLanguages();

    if ((_this$existing3 = this.existing) !== null && _this$existing3 !== void 0 && _this$existing3.id) {
      var language = _.first(Object.keys(this.existing.languages));

      this.seriesName = this.existing.languages[language].title;
      this.seriesDescription = this.existing.languages[language].description;
      this.seriesLanguage = language;
      this.seriesValidity = this.existing.expiration;
      this.seriesCertification = this.existing.certificates;
    }
  },
  methods: {
    worldLanguages: function worldLanguages() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var api, locale, userLang, languages;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                api = 'https://restcountries.com/v2/all?fields=name,translations,flags,independent,languages,alpha2Code';
                locale = _this.$i18n.locale;
                userLang = _.first(locale.split('-'));
                languages = [{}];
                _context.next = 6;
                return axios.get(api).then(function (response) {
                  var data = response.data;

                  _.forEach(data, function (item) {
                    if (locale === "".concat(item.languages[0].iso639_1, "-").concat(item.alpha2Code.toLowerCase())) {
                      languages[0] = {
                        label: "".concat(item.languages[0].nativeName, " (").concat(item.translations[userLang], ")"),
                        value: "".concat(item.languages[0].iso639_1, "-").concat(item.alpha2Code.toLowerCase())
                      };
                    }

                    if (item.independent && item.languages[0].iso639_1 !== userLang) {
                      languages.push({
                        label: "".concat(item.languages[0].nativeName, " (").concat(item.translations[userLang], ")"),
                        value: "".concat(item.languages[0].iso639_1, "-").concat(item.alpha2Code.toLowerCase())
                      });
                    }
                  });

                  _this.languages = languages;
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    toogleCheckbox: function toogleCheckbox(value) {
      this.seriesCertification = value;
    },
    handleTitleChange: function handleTitleChange() {
      var text = this.seriesName;

      if (this.seriesName) {
        var slug = utils.convertExpressionToSlug(text);
        this.seriesSlug = slug;
      }
    }
  }
};